import { createStyles } from '@/contexts/theme-context';
import { NavIcon } from '@/experiences/shared/components/nav-icon';
import { NavItemIcon } from '@/domain/navigation/types';
import { Pressable } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

const ICON_SIZE = 16;

interface SidebarNavItemProps {
  active?: boolean;
  /** Icon component for hardcoded nav items. */
  icon?: NavItemIcon;
  /** Icon URL for dynamic nav items from the API. */
  iconUrl?: string;
  label?: string;
  onPress: () => void;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  active,
  icon,
  iconUrl,
  label,
  onPress,
}) => {
  const [styles, theme] = useStyles();

  const iconColor = active
    ? theme.sk.color.icon.primary
    : theme.sk.color.icon.secondary;

  return (
    <Pressable
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [
        styles.navItem,
        ...(active ? [styles.navItemActive] : []),
        ...(pressed && !active ? [styles.navItemPressed] : []),
      ]}
    >
      <NavIcon
        color={iconColor}
        icon={icon}
        iconUrl={iconUrl}
        size={ICON_SIZE}
      />
      {label ? (
        <Typography
          color={
            active ? theme.sk.color.text.primary : theme.sk.color.text.secondary
          }
          variant={active ? 'paragraph-md-600' : 'paragraph-md'}
        >
          {label}
        </Typography>
      ) : null}
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  navItem: {
    alignItems: 'center',
    borderRadius: theme.sk.radii.radiusSmall,
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    height: theme.sk.spacing.spaceXlarge,
    paddingHorizontal: theme.sk.spacing.spaceSmall,
    width: '100%',
  },
  navItemActive: {
    backgroundColor: theme.sk.color.bg.secondary.default,
  },
  navItemPressed: {
    opacity: 0.7,
  },
}));
